<script setup lang="ts">
import type {IntlService} from "@progress/kendo-vue-intl";
import {inject} from "vue";
import {useUxData} from "@/stores/ux-data.ts";

const ux = useUxData();
const kendo: IntlService = inject('kendo') as IntlService
const props = defineProps<{
  heading?: string,
  price?: number,
  period?: string,
  periodEnd?: string|number|null,
  cancelsOn?: string|number|null,
  lastUpdated?: string|number|null,
  features?: string[],
  currentPlan?: boolean,
}>()
</script>

<template>
  <div class="card h-100 border-info">
    <div class="card-header text-center fw-bold text-uppercase border-info bg-info-subtle"
         v-html="heading"
    ></div>
    <div v-if="cancelsOn" class="cancellation-date">
      {{ kendo.format(ux.labels.profile.subscription.cancelDateFormatString, kendo.formatDate(new Date(cancelsOn), 'D')) }}
    </div>
    <div v-else-if="periodEnd" class="renewal-date">
      {{ kendo.format(ux.labels.profile.subscription.renewalDateFormatString, kendo.formatDate(new Date(periodEnd), 'D')) }}
    </div>
    <div class="card-body">
      <div class="price">
        {{ kendo.formatNumber(price / 100, 'c') }}
        <span v-if="period" class="period">/ {{ period }}</span>
      </div>
      <div class="features mx-n3">
        <ul v-if="features.length > 0" class="list-group list-group-flush">
          <li v-for="feature in features" class="list-group-item" v-html="feature"></li>
        </ul>
      </div>
    </div>
    <div v-if="lastUpdated" class="last-modified-date">
      {{ kendo.format(ux.labels.profile.subscription.updatedDateFormatString, kendo.formatDate(new Date(lastUpdated), 'd'), kendo.formatDate(new Date(lastUpdated), 'hh:mm a')) }}
    </div>
  </div>
</template>
